import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-header">
        <div className="container">
          <div className="header-content">
            <h1>About Us</h1>
            <p>Discover our story of craftsmanship and dedication to quality</p>
          </div>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="content-grid">
            <div className="about-text">
              <h2>Our Story</h2>
              <p>
                At Leather Categories, we are passionate about creating premium handcrafted 
                leather products and percussion instruments. Our journey began with a simple 
                mission: to provide musicians and enthusiasts with the highest quality 
                leather goods that combine traditional craftsmanship with modern design.
              </p>
              <p>
                Each piece is carefully crafted using the finest materials and time-honored 
                techniques, ensuring durability, functionality, and aesthetic appeal.
              </p>
            </div>

            <div className="about-values">
              <h2>Our Values</h2>
              <ul className="values-list">
                <li>
                  <h3>Quality Craftsmanship</h3>
                  <p>We take pride in our attention to detail and commitment to excellence.</p>
                </li>
                <li>
                  <h3>Sustainable Practices</h3>
                  <p>We source our materials responsibly and minimize environmental impact.</p>
                </li>
                <li>
                  <h3>Customer Satisfaction</h3>
                  <p>Your satisfaction is our priority, and we stand behind every product.</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="container">
          <h2>Experience Our Craftsmanship</h2>
          <p>Browse our collection of handcrafted leather products</p>
          <button className="cta-button" onClick={() => window.location.href = '/products'}>
            View Products
          </button>
        </div>
      </section>
    </div>
  );
};

export default About;
